import React from "react"
import ReactPaginate from "react-paginate"
import "./styles.css"

export const PaginationGrid = ({ currentPage, onPageChange, totalPages }) => (
  <ReactPaginate
    pageCount={totalPages}
    pageRangeDisplayed={3}
    marginPagesDisplayed={1}
    previousLabel={
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 19l-7-7 7-7"
        />
      </svg>
    }
    nextLabel={
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
    }
    onPageChange={data => onPageChange(data.selected + 1)}
    forcePage={currentPage - 1}
    containerClassName="pagination-container"
    pageClassName="pagination-item"
    pageLinkClassName="pagination-link"
    previousClassName="pagination-item"
    previousLinkClassName="pagination-link"
    nextClassName="pagination-item"
    nextLinkClassName="pagination-link"
    breakClassName="pagination-item"
    breakLinkClassName="pagination-link"
    activeClassName="active"
    disabledClassName="disabled"
  />
)
